import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { takeUntil, filter } from 'rxjs/operators';
import { Subject, Unsubscribable, BehaviorSubject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { get } from 'lodash';

import {
  UserService,
  BroadcastService,
  Event,
  UserAuth
} from '@nrwl/common-lib';

import { ProfileSettingsUpdater } from '../profile-settings-updater';

@Component({
  selector: 'nrwl-user-preferences',
  templateUrl: './user-preferences.component.html',
  styleUrls: ['./user-preferences.component.scss']
})
export class UserPreferencesComponent
  extends ProfileSettingsUpdater
  implements OnInit, OnDestroy {
  @Input() showAlertsPreference: boolean;
  @Input() showThemePreference: boolean;
  alertPreferenceSubject: BehaviorSubject<any>; //eslint-disable-line
  alertPreferenceData: any; //eslint-disable-line
  userName: string;
  defaultTheme = 'light';
  isEmailNotificationEnabled: boolean;
  webUIPreferenceUnsubscribable: Unsubscribable;
  private readonly unsubscribe: Subject<void> = new Subject();

  constructor(
    userService: UserService,
    private readonly broadcastService: BroadcastService,
    activatedRoute: ActivatedRoute,
    userAuth: UserAuth
  ) {
    super(userService, activatedRoute, userAuth);
  }

  ngOnInit() {
    this.alertPreferenceSubject = new BehaviorSubject({});
    this.userName = this.getQueryUserName();
    this.userService.profileEvents
      .pipe(
        takeUntil(this.unsubscribe),
        filter(
          event =>
            event.event === 'user-prefs' && this.userName === event.username
        )
      )
      .subscribe(event => {
        this.defaultTheme = get(event, 'prefs.userSettings.theme', 'light');
      });

    if (this.showAlertsPreference) {
      this.userService
        .getUserEmailNotification(this.userName)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(response => {
          this.alertPreferenceData = response.alertsPreference;
          this.alertPreferenceSubject.next(response.alertsPreference);
          this.isEmailNotificationEnabled = get(
            response,
            'alertsPreference.isEmailNotificationEnabled',
            false
          );
        });
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribeUpdates();
    if (this.webUIPreferenceUnsubscribable) {
      this.webUIPreferenceUnsubscribable.unsubscribe();
    }
  }

  onChangeTheme(event: any): void { //eslint-disable-line
    this.broadcastService.broadcastEvent(
      new Event('appComponent', 'changeTheme', {
        theme: event.value,
        userName: this.userName
      })
    );
  }

  onEnableOverallEmailAlertsChange(event: any): void { //eslint-disable-line
    this.alertPreferenceData.isEmailNotificationEnabled = event.checked;
    this.alertPreferenceSubject.next(this.alertPreferenceData);
    this.updateUserAlertsPreferences(this.alertPreferenceData);
  }
}
